import {mapView, mapViewCenter, mapViewExtent} from '@mapsight/ui/config';

export const MIN_ZOOM = 15;
export const MAX_ZOOM = 17;

export default mapView(
	mapViewCenter(1054900, 7094650),
//	mapViewExtent(231663, 5671953, 2083274, 7760824), // minx, miny, maxx, maxy
	mapViewExtent(1052623.8711,7091588.6186,1058375.7575,7097474.2698),
	15, // z
	MIN_ZOOM,
	MAX_ZOOM
);
